export const OTPTypes = {
	Other: 0,
	Authentication: 1,
	Transaction: 2,
	PasswordReset: 3,
	IbanChange: 4,
	DeviceTrust: 5,
	DeviceForget: 6,
};
